import { render, staticRenderFns } from "./AssetView.vue?vue&type=template&id=1d865eb6&scoped=true&lang=pug&"
import script from "./AssetView.vue?vue&type=script&lang=js&"
export * from "./AssetView.vue?vue&type=script&lang=js&"
import style0 from "./AssetView.vue?vue&type=style&index=0&id=1d865eb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d865eb6",
  null
  
)

export default component.exports